import type {Instance} from 'tippy.js';
import tippy from 'tippy.js';

import './tooltip.less'
import {isString} from 'shared/utils/string-utils'; // to bundle tooltip styles

export interface TooltipConfiguration {
    content: string;
    role: 'tooltip' | 'note';
    enabled: boolean;
}

export function tooltip(elem: HTMLElement, contentOrConfig: string | TooltipConfiguration) {
    let instance: Instance;

    if (isString(contentOrConfig)) {
        instance = tippy(elem, {content: contentOrConfig, zIndex: 1000000, duration: [null, 0], role: 'tooltip'});
    } else {
        instance = tippy(elem, {content: contentOrConfig.content, zIndex: 1000000, duration: [null, 0], role: contentOrConfig.role});

        if (!contentOrConfig.enabled) {
            instance.disable();
        }
    }

    return {
        update: (updatedContentOrConfig: string | TooltipConfiguration) => {
            if (isString(updatedContentOrConfig)) {
                instance.setContent(updatedContentOrConfig);
            } else {
                instance.setContent(updatedContentOrConfig.content);

                if (updatedContentOrConfig.enabled) {
                    instance.enable();
                } else {
                    instance.disable();
                }
            }
        },
        destroy: () => {
            instance.destroy();
        }
    }
}